import {
    Component,
    Input,
    HostBinding,
    Output,
    EventEmitter
} from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

import { ConstantsService } from '../../core/upgraded-providers';

import {
    ShowDlgTransferService
} from '../../shared-dialogs.module/show-dlg-transfer.service';
import {
    ITEM_SHOP_URL
} from '../store-urls';

@Component({
    selector: 'app-store-pixel',
    templateUrl: './store-pixel.component.pug',
    styleUrls: ['./store-pixel.component.less']
})
export class StorePixelComponent {
    @HostBinding('class.--ui') _ui = true;

    itemShopUrl = ITEM_SHOP_URL;

    @HostBinding('attr.disabled') disabled;

    @Input() steam: any;

    _amountSbj: BehaviorSubject<number> = new BehaviorSubject(0);
    amount$: Observable<number> = this._amountSbj.asObservable();
    @Input() set amount(amount: number) {
        this._amountSbj.next(amount >= 0 ? amount : 0);
    }

    @Output() close: EventEmitter<any> = new EventEmitter();
    @Output() transfer: EventEmitter<any> = new EventEmitter();

    PIXEL_CPU_COST = this._constantsSrv.PIXEL_CPU_COST;

    constructor(
        private _constantsSrv: ConstantsService,

        private _dlgTransferSrv: ShowDlgTransferService
    ) {
    }

    onClose() {
        this.close.emit();
    }

    async onTransfer() {
        this._disable();

        let count;
        try {
            count = await this._dlgTransferSrv.show({
                limit: this._amountSbj.getValue(),
                title: 'How many <span class="--color-text-pixels">Pixels</span> do you want to transfer?',
                button: 'Transfer&nbsp;<app-icon-pixel></app-icon-pixel>&nbsp;to Steam'
            });
        } catch (err) {
            console.debug('StorePixelComponent::onTransfer', err);

            this._enable();
            return;
        }

        this.transfer.emit(count);
    }

    _disable() {
        this.disabled = true;
    }

    _enable() {
        this.disabled = false;
    }
}
